module.exports = __webpack_public_path__ + "static/media/small_baloon2.648c8b69.svg";